import * as React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import { Nav, Navbar, NavDropdown, Dropdown } from 'react-bootstrap'
import { FaEnvelope, FaQuestion, FaYammer } from 'react-icons/fa'

import { Action } from 'typescript-fsa'
import { Router } from './pages/Router/Router'
import { UnhandledExceptionHandlerContainer } from './pages/UnhandledExceptionHandler/UnhandledExceptionHandlerContainer'
import * as _ from 'lodash'
import ReportGroup from './model/ReportGroup'
import { IMonitoringService } from './common/IMonitoringService'
import { configuration } from './rest-api/Configuration'
import { Button, Card } from 'react-bootstrap'
import { IMessageService } from './common/IMessageService'
import { MessageBoard } from './common/MessageBoard'
import { getAccountName } from './auth/authProvider'

export interface StateProps {
  errorMessage: string
  reportGroups?: _.Dictionary<ReportGroup[]>
  reportGroupsLoading: boolean
  monitoringService: IMonitoringService
  messageService: IMessageService
}

interface State {
  accountName: string | null
}

export interface DispatchProps {
  clearErrorMessage: () => Action<void>
}

type Props = StateProps & DispatchProps & RouteComponentProps

export default class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { accountName: null }
  }

  componentDidMount() {
    getAccountName().then(accountName => this.setState({ accountName }))
    const { monitoringService } = this.props
    monitoringService.logEvent('Session Start')
    const root = window.location.origin
    monitoringService.logPageView(undefined, root + window.location.pathname)
    if (this.props.history) {
      this.props.history.listen(location => {
        monitoringService.logPageView(undefined, root + location.pathname)
      })
    }
  }

  componentWillUnmount() {
    this.props.monitoringService.logEvent('Session End')
  }

  smartLogo = (): JSX.Element => 
        <Navbar.Brand as={Link} to="/">
          <img style={{ height: '2em' }} src="/smart_whitelogo.svg" alt="SMART 2.0" />
        </Navbar.Brand>

  render() {
    return (
      <div className="App parent">
        <MessageBoard messageService={this.props.messageService} />
        <Navbar className={configuration.Name.toLowerCase()}>
          {this.smartLogo()}
          <Navbar.Collapse>
            <Nav>
              <NavDropdown id="other-apps" title="Applications">
                {configuration.SmartApplications.map((group, groupIndex) => (
                  <span key={groupIndex}>
                    {group.Applications.map(a => (
                      <Dropdown.Item
                        key={a.Name}
                        href={a.Url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {a.Name}
                      </Dropdown.Item>
                    ))}
                    {groupIndex === configuration.SmartApplications.length - 1 ? null : (
                      <Dropdown.Divider />
                    )}
                  </span>
                ))}
              </NavDropdown>
            </Nav>

            <Nav.Link as={Link} to="/">
              Sites
            </Nav.Link>
            <Nav.Link as={Link} to="/reports">
              Reports
            </Nav.Link>
          </Navbar.Collapse>
          <Nav>
            <Navbar.Text>User:&nbsp;{this.state.accountName ?? "Unknown"}</Navbar.Text>
            <Nav.Link href="mailto:SMARTSupport@res-group.com" title="Support Email">
              <FaEnvelope />
            </Nav.Link>
            <Nav.Link
              href="https://www.yammer.com/res-group.com/#/threads/inGroup?feedId=14425392"
              title="SMART Users Yammer Channel"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYammer />
            </Nav.Link>
            <Nav.Link as={Link} to="/help" title="Help">
              <FaQuestion />
            </Nav.Link>
          </Nav>
        </Navbar>
        <UnhandledExceptionHandlerContainer>
          {this.props.errorMessage === '' ? (
            <Router messageService={this.props.messageService} />
          ) : (
            <Card className="alert alert-danger">
              <h1>Encountered an error: {this.props.errorMessage}</h1>
              <div>
                Please contact the SMART team at{' '}
                <a href="mailto:smartsupport@res-group.com">smartsupport@res-group.com</a>.
              </div>
              <Button onClick={this.props.clearErrorMessage}>Attempt to recover</Button>
            </Card>
          )}
        </UnhandledExceptionHandlerContainer>
      </div>
    )
  }
}
